import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./languageSlice"; // Import the language slice

// Function to save state to local storage
const saveStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('reduxState', serializedState);
  } catch (e) {
    console.warn('Could not save state', e);
  }
};

// Function to load state from local storage
const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn('Could not load state', e);
    return undefined;
  }
};

// Load persisted state
const persistedState = loadStateFromLocalStorage();

const store = configureStore({
  reducer: {
    language: languageReducer,
  },
  preloadedState: persistedState, // Use persisted state
});

// Subscribe to store changes to save state
store.subscribe(() => {
  saveStateToLocalStorage(store.getState());
});

export default store;
